<template>
  <v-master>
    <div class="container relative max-w-lg">
      <div class="py-14">
        <p class="heading mb-3 text-center">
          Quiz
        </p>

        <h1 class="title-1 mb-8 text-center">
          Take the following quiz to determine your carbon footprint
        </h1>

        <router-view />
      </div>
    </div>
  </v-master>
</template>
<script>
export default {
  name: "v-quiz-layout",
};
</script>
